import React, { useState } from 'react';
import { Icon } from '../Icon';
import './GoalAmountInput.css';

interface GoalAmountInputProps {
  value: number;
  onChange: (value: number) => void;
  onNext: () => void;
  onBack: () => void;
  currency?: string;
}

// Символы валют
const currencySymbols: Record<string, string> = {
  'RUB': '₽',
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'CNY': '¥',
  'JPY': '¥',
  'INR': '₹',
  'KRW': '₩',
  'TRY': '₺',
};

export const GoalAmountInput: React.FC<GoalAmountInputProps> = ({ 
  value, 
  onChange, 
  onNext, 
  onBack, 
  currency = 'RUB' 
}) => {
  const [display, setDisplay] = useState(value > 0 ? value.toString() : '0');
  const currencySymbol = currencySymbols[currency] || currency;

  const handleNumberClick = (num: string) => {
    if (display === '0') {
      setDisplay(num);
    } else if (display.length < 10) {
      setDisplay(display + num);
    }
  };

  const handleDot = () => {
    if (!display.includes('.')) {
      setDisplay(display + '.');
    }
  };

  const handleClear = () => {
    setDisplay('0');
  };

  const handleBackspace = () => {
    if (display.length === 1) {
      setDisplay('0');
    } else {
      setDisplay(display.slice(0, -1));
    }
  };

  const handleSubmit = () => {
    const amount = parseFloat(display);
    if (amount > 0) {
      onChange(amount);
      onNext();
    }
  };

  const quickAmounts = [1000, 5000, 10000, 50000];

  const handleQuickAmount = (amount: number) => {
    setDisplay(amount.toString());
  };

  return (
    <div className="goal-amount-input step-content">
      <div className="goal-amount-input__header">
        <button className="goal-amount-input__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="goal-amount-input__header-content">
          <h2 className="goal-amount-input__title">Целевая сумма</h2>
          <p className="goal-amount-input__subtitle">
            Сколько хотите накопить?
          </p>
        </div>
      </div>

      <div className="goal-amount-input__display neo-inset">
        <div className="goal-amount-input__display-value">{display}</div>
        <div className="goal-amount-input__display-currency">{currencySymbol}</div>
      </div>

      <div className="goal-amount-input__quick">
        <div className="goal-amount-input__quick-title">Быстрый выбор:</div>
        <div className="goal-amount-input__quick-buttons">
          {quickAmounts.map((amount) => (
            <button
              key={amount}
              className="quick-amount-btn neo-raised"
              onClick={() => handleQuickAmount(amount)}
            >
              {amount.toLocaleString()}
            </button>
          ))}
        </div>
      </div>

      <div className="goal-amount-input__keypad">
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('1')}>1</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('2')}>2</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('3')}>3</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('4')}>4</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('5')}>5</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('6')}>6</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('7')}>7</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('8')}>8</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('9')}>9</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={handleDot}>.</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('0')}>0</button>
          <button className="keypad-btn neo-raised keypad-btn--action" onClick={handleBackspace}>⌫</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised keypad-btn--clear" onClick={handleClear}>Очистить</button>
          <button 
            className="keypad-btn neo-raised keypad-btn--submit" 
            onClick={handleSubmit}
            disabled={parseFloat(display) <= 0}
          >
            Далее
          </button>
        </div>
      </div>
    </div>
  );
};

